<template>
	<v-card elevation="0" class="ant-card mt-6 pa-4">
		<v-card-title class="pa-0 d-flex align-center">
			<div class="v-typography--title1">{{ $t("attributes") }}</div>
			<v-spacer />
			<v-btn text outlined @click="$emit('add')">
				<v-icon size="15" left>icon-plus</v-icon>
				<span class="v-typography--body-sm">{{ $t("add_attribute") }}</span>
			</v-btn>
		</v-card-title>
		<v-divider class="my-3" />
		<v-simple-table dense>
			<thead>
				<tr>
					<th>{{ $t("name") }}</th>
					<th>{{ $t("type") }}</th>
					<th>{{ $t("options") }}</th>
					<th class="text-right">{{ $t("actions") }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="attr in attributes" :key="attr._id">
					<td>{{ attr.nameText }}</td>
					<td>{{ attributeTypeLabel(attr.type) }}</td>
					<td>
						<span v-if="attr.type === 'multi_select'">
							{{ attr.options.map((o) => o.valueText).join(", ") }}
						</span>
						<span v-else>–</span>
					</td>
					<td class="text-right">
						<v-btn icon small @click="$emit('edit', attr)">
							<v-icon size="18">icon-edit</v-icon>
						</v-btn>
						<v-btn icon small @click="$emit('delete', attr._id)">
							<v-icon size="18" color="red">icon-delete</v-icon>
						</v-btn>
					</td>
				</tr>
			</tbody>
		</v-simple-table>
	</v-card>
</template>

<script>
export default {
	name: "ProductAttributes",
	props: { attributes: { type: Array, required: true } },
	methods: {
		attributeTypeLabel(type) {
			if (type === "multi_select") return this.$t("multiple_select");
			if (type === "boolean") return this.$t("yes_no");
			if (type === "text") return this.$t("text_input");
			return this.$t("date_input");
		},
	},
};
</script>
